export default __webpack_public_path__ + "static/media/03_gold 1.650d2b9a.svg";